export const DEFAULT_DRAWER_DETAIL_WIDTH = 1120;
export const RESIZABLE_MIN_WIDTH = 68;
export const SORT_DIRECTIONS: ('descend' | 'ascend')[] = ['descend', 'ascend'];
export const DEFAULT_PAGE_SIZE = 50;

export const EMPTY_PAYEE_ARRAY: string[] = [];
export const ACTION_BUTTONS_GAP = 8;

/** Only show tags for fields the user explicitly filtered by */
export const INVOICE_REPORTS_ALWAYS_SHOW_FIELDS: string[] = [];
/** Static exclusions for active tag fields. Use dynamic excludeFields in Search for feature-flag-driven exclusions. */
export const EXCLUDED_ACTIVE_TAG_FIELDS: string[] = [];
